import React, { FunctionComponent } from 'react';
import withStyles from 'react-jss';
import { Grid, Header, Icon } from 'semantic-ui-react';
import { FormattedDate } from 'react-intl';
import moment from 'moment';

import { Theme } from 'config';
import { ClassProp } from 'helpers/types';

/**
 * This is the corresponding type for ReportInput in the GraphQL.
 * This is used to type all params to be used as arguments in the reports queries.
 */
export type ReportParams = {
  startDate?: string;
  endDate?: string;
  merchantName?: string;
  merchantId?: string;
  campaignStartDate?: string;
  campaignEndDate?: string;
  timeslice?: string;
  email?: string;
  jobUuid?: string;
  reportList: string[];
};

const styles = (theme: Theme) => ({
  merchantName: {
    color: `${theme.violet} !important`,
    marginBottom: '8px !important',
  },
  subtitle: {
    color: `${theme.darkGray} !important`,
    margin: '8px 0 !important',
  },
});

const formattedDatePropsDefault = {
  year: 'numeric',
  month: 'short',
  day: '2-digit',
};

export type FormattedDateProps = {
  year?: string;
  month?: string;
  day?: string;
};

type Props = {
  classes: ClassProp<ReturnType<typeof styles>>;
  reportParams: ReportParams;
  formattedDateProps?: FormattedDateProps;
};

const renderMerchant = ({ classes, reportParams: { merchantName } }: Props) => (
  <Grid.Column textAlign="left" width={16}>
    <Header className={classes.merchantName} as="h4">
      {merchantName}
    </Header>
  </Grid.Column>
);

const renderDateRange = ({
  classes,
  formattedDateProps = formattedDatePropsDefault,
  reportParams: { startDate, endDate, campaignStartDate, campaignEndDate },
}: Props) => (
  <Grid.Column textAlign="left" width={16}>
    <Header className={classes.subtitle} as="h5">
      <span>
        <Icon name="calendar alternate outline" />
      </span>

      <FormattedDate
        value={moment(startDate || campaignStartDate, 'YYYY-MM-DD').toDate()}
        {...formattedDateProps}
      />

      <span> to </span>

      <FormattedDate
        value={moment(endDate || campaignEndDate, 'YYYY-MM-DD').toDate()}
        {...formattedDateProps}
      />
    </Header>
  </Grid.Column>
);

const ParamsHeader: FunctionComponent<Props> = (props) => (
  <Grid>
    <Grid.Row>
      {renderMerchant(props)}
      {renderDateRange(props)}
    </Grid.Row>
  </Grid>
);

export default withStyles(styles)(ParamsHeader);
